import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesReturn, SalesReturnCreate, SalesReturnFilter } from '../data/salesReturn';

export function createSalesReturnService(client: AxiosInstance) {
  return createCrudService<SalesReturn, SalesReturnCreate, SalesReturnFilter>(
    client,
    '/sales/SalesReturn',
    'salesReturnId',
  );
}

export type SalesReturnService = CrudService<SalesReturn, SalesReturnCreate, SalesReturnFilter>;
